module.exports = __webpack_public_path__ + "img/08.7669592a.png";